export default [
    {
        path: '/web/search',
        component: () => import('@/web/search')
    },
    {
        path: '/flix.ru',
        component: () => import('@/web/online-cinema/theme3')
    },
    {
        path: '/www.fryd.ru',
        component: () => import('@/web/online-cinema/theme2')
    },
    {
        path: '/www.online.ru',
        component: () => import('@/web/online-cinema/theme1')
    },
    {
        path: '/mnogobiletov.ru',
        component:  () => import('@/web/mnogobiletov.ru')
    },
    {
        path: '/web/wiki-cinema',
        component:  () => import('@/web/wiki-cinema')
    },
    {
        path: '/www.afisha.ru',
        component:  () => import('@/web/afisha.ru')
    }
]